export const selectUserRole = store => store.session.user?.role;
export const selectUserEmail = store => store.session.user?.email;
export const selectIsSuperAdminSession = store => store.session.isSuperAdminSession;
